export var LayerDirectionEnum;
(function (LayerDirectionEnum) {
    LayerDirectionEnum[LayerDirectionEnum["TB"] = 0] = "TB";
    LayerDirectionEnum[LayerDirectionEnum["LR"] = 1] = "LR";
    LayerDirectionEnum[LayerDirectionEnum["BT"] = 2] = "BT";
    LayerDirectionEnum[LayerDirectionEnum["RL"] = 3] = "RL";
    LayerDirectionEnum[LayerDirectionEnum["None"] = 4] = "None";
})(LayerDirectionEnum || (LayerDirectionEnum = {}));
//# sourceMappingURL=layerDirectionEnum.js.map